import { forwardRef } from 'react';
import { SnackbarContent } from 'notistack';
import NotificationCard from './NotificationCard';
import { INotification } from 'src/app/types';

interface NotificationTemplateProps {
  item: INotification;
  onClose?: () => void;
  counter?: number;
}

const NotificationTemplate = forwardRef<any, NotificationTemplateProps>((props, ref) => {
  const { item, counter = 0 } = props;

  return (
    <SnackbarContent
      ref={ref}
      className="mx-auto max-w-320 w-full relative pointer-events-auto py-4"
    >
      <NotificationCard notification={item} onClose={props.onClose} counter={counter} />
    </SnackbarContent>
  );
});

export default NotificationTemplate;
